import styled from 'styled-components';
import {themecolors} from "../utils/themecolors";

const Moderator = styled.div``;
const Admin = styled.div``;
const OP = styled.div``;
const Pro = styled.div``;
const BasicPro = styled.div``;

const RoleIndicator = styled(({className, admin, mod, op, proTier}) => {
    return (
        <div className={className}>
            {mod && <Moderator>Mod </Moderator>}
            {admin && <Admin>Admin </Admin>}
            {op && <OP>OP </OP>}
            {proTier === 1 &&
            <BasicPro>PRO</BasicPro>
            }
            {proTier === 2 &&
            <Pro>PRO</Pro>
            }
        </div>
    );
})`
  display: flex;

  ${Moderator},
  ${Admin},
  ${OP},
  ${Pro},
  ${BasicPro} {
    margin-left: 4px;
    font-weight: 500;
  }

  ${Moderator} {
    color: ${themecolors.green};
    font-weight: 600;
  }

  ${Admin} {
    color: ${themecolors.red};
    font-weight: 600;
  }

  ${OP} {
    color: #2086f3;
  }

  ${Pro}, ${BasicPro} {
    border-radius: 2px;
    margin: 0 6px;
    display: flex;
    align-items: center;
    padding: 0 6px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    font-weight: 500;
    font-size: 11px;
  }
`;

export default RoleIndicator;
